import { getLanguage } from 'core/i18n';
const { generatePublicUrl } = require('utilities/multiLanguageHelper');

let publicUrl = 'https://www.openbank.es/';
let privateUrl = 'https://clientes.openbank.es/';
let allowCookie = false;
let publicUrl_original = 'https://www.openbank.es/';
const publicLoginUrl = 'https://login.openbank.es';
const loginDesktopToggle = '?toggleLogin';
const loginMobileToggle = '?toggleLogin&go-to-app=0';

if (__PUBLIC_URL__) {
    publicUrl = __PUBLIC_URL__;
    publicUrl_original = __PUBLIC_URL__;
}

if (__PRIVATE_URL__) {
    privateUrl = __PRIVATE_URL__;
}

const basePath = __STATIC_PREFIX_ONBOARDING__;

if (typeof __ALLOW_COOKIE__ !== 'undefined') {
    allowCookie = __ALLOW_COOKIE__;
}

publicUrl = generatePublicUrl(publicUrl, getLanguage());
privateUrl = generatePublicUrl(privateUrl, getLanguage());

export default {
    LOCAL_ENVIRONMENT: 'local',
    DEV_ENVIRONMENT: 'dev',
    QA_ENVIRONMENT: 'qa',
    STG_ENVIRONMENT: 'stg',
    PROD_HIDDEN_ENVIRONMENT: 'ocu',
    PROD_ENVIRONMENT: 'pro',
    BASE_PATH: basePath,
    PUBLICA_URL: publicUrl,
    PUBLICA_LOGIN_URL: publicLoginUrl,
    PRIVATE_URL: privateUrl,
    ALLOW_COOKIE: allowCookie,
    PUBLICA_URL_ROOT: publicUrl_original,
    PRIVATE_HIRE_CREDIT_CARD: 'myprofile/hire/card',
    API_APPLICATION: 'api',
    LOGIN_DESKTOP: loginDesktopToggle,
    LOGIN_MOBILE: loginMobileToggle,
};
